export default {
    data() {
        return {
            valid: {
                mapper: {
                    transaction: false,
                    user: false
                },
            },
            success: {
                mapper: {
                    transaction: false,
                    user: false
                },            
            },
            error: {
                mapper: {
                    transaction: "",
                    user: ""
                },            
            },
            errorMessages: {
                mapperInvalid: {
                    el: "Μη έγκυρo JSON",
                    en: "Invalid JSON",
                    it: "JSON non valido"
                },
            }
        };
    },

    computed: {
        formValid() {
            return this.valid.mapper.transaction && this.valid.mapper.user;
        },
    },

    methods: {
        resetValidation(){
            this.valid = {
                mapper: {
                    transaction: false,
                    user: false
                },            
            };
            this.success = {
                mapper: {
                    transaction: false,
                    user: false
                },    
            };
            this.error = {
                mapper: {
                    transaction: "",
                    user: ""
                },              
            };

        },
        
        validateMapper(item) {
            this.valid.mapper[item.event_name] = false;
            this.success.mapper[item.event_name] = false;

            if (item.mapper &&!this.isValidJSON(item.mapper)) {
                    this.error.mapper[item.event_name] = this.errorMessages.mapperInvalid[
                        this.lang
                    ];
            } else {
                this.error.mapper[item.event_name] = "";
                this.valid.mapper[item.event_name] = true;
                this.success.mapper[item.event_name] = true;
            }
            return item
        },
     
        isValidJSON(str) {
            try {
                JSON.parse(JSON.stringify(str));
                return true;
              } catch(e) {
                return false
              }
        },

    
    },

    watch: {
      
        eventResponses: {
            handler(val) {
                if (val) {
                   val.forEach(e => {
                        this.validateMapper(e)
                   });
                }
            },
            deep: true
        },

    },
    // mounted() {
    //     this.eventResponses.forEach(e => {
    //         this.validateMapper(e)
    //    });
    // },
};
